var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7428 0.441406H2.03522C1.39293 0.441406 0.874023 0.960318 0.874023 1.60261V28.3102C0.874023 28.9525 1.39293 29.4714 2.03522 29.4714H28.7428C29.3851 29.4714 29.904 28.9525 29.904 28.3102V1.60261C29.904 0.960318 29.3851 0.441406 28.7428 0.441406ZM25.3898 8.91454H23.0711C21.253 8.91454 20.9011 9.77818 20.9011 11.0483V13.846H25.2411L24.675 18.2259H20.9011V29.4714H16.376V18.2295H12.5913V13.846H16.376V10.6164C16.376 6.86792 18.6658 4.82494 22.0115 4.82494C23.6154 4.82494 24.9907 4.94468 25.3935 4.99912V8.91454H25.3898Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9977,
    height: 29.03,
    fill: "white",
    transform: "translate(0.000976562 0.441406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial3);
export default __webpack_public_path__ + "static/media/Social-3.95eea0092d3b64e702a8a1eea130fee4.svg";
export { ForwardRef as ReactComponent };